<template>
  <el-dialog title="交易商认证协议" :visible.sync="innerVisible" width="1000px">
    <div class="agreement-content">
      <p v-for="(item, index) in paragraphs" :key="index" :class="item.cls">
        <span v-if="item.cls === 'p-signature'" class="sig-left">甲方：新疆煤炭交易中心有限公司</span>
        <span v-if="item.cls === 'p-signature'" class="sig-right">乙方：交易商</span>
        <template v-else>
          <span v-for="(seg, i) in toSegments(item)" :key="i" :class="{ 'seg-bold': seg.bold }">{{
            seg.text
          }}</span>
        </template>
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 企业认证协议弹窗
 * 正文内容严格按照《新疆煤炭交易中心有限公司交易商入市认证协议》Word 文档原样录入，
 * 未修改文档中任何文字内容（含原文档中条目编号的跳号，如第八条下 8 后直接为 10）。
 * 格式按文档段落属性还原：标题居中加粗、章节标题无缩进、正文首行缩进 2 字符、两端对齐。
 */
const C = {
  title: "p-title",
  party: "p-party",
  preface: "p-preface",
  section: "p-section",
  body: "p-body",
  blodBody: "p-blod-body",
  blank: "p-blank",
  signature: "p-signature",
};

export default {
  name: "EnterpriseAgreementDlg",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    paragraphs() {
      return [
        { cls: C.title, text: "新疆煤炭交易中心有限公司" },
        { cls: C.title, text: "交易商认证协议" },
        { cls: C.party, text: "甲方：新疆煤炭交易中心有限公司" },
        { cls: C.party, text: "乙方：交易商" },
        {
          cls: C.preface,
          text: "依据《中华人民共和国民法典》和相关法律、法规，甲方与交易商资格申请人（以下简称“乙方”）遵循平等、自愿、互利的原则，就乙方向甲方申请交易商资格，使用甲方提供的“新疆煤炭交易中心交易平台”（以下简称“交易平台”），经协商达成如下协议：",
        },
        { cls: C.section, text: "一、声明" },
        {
          cls: C.body,
          text: "第一条乙方在使用交易平台服务前，须务必认真阅读本协议各项条款并充分理解接受本协议须知约束。不同意接受本协议须知的，应立即停止注册、认证和使用交易平台的各项服务。",
        },
        {
          cls: C.body,
          text: "第二条甲方作为第三方交易服务机构，既不是煤炭买卖经营主体，也不拥有煤炭资源，不介入煤炭买卖购销链条，仅为煤炭买卖经营主体提供第三方交易组织、合同签订、物流衔接、金融服务、能源资讯等服务。",
        },
        {
          cls: C.body,
          text: "第三条乙方系在中华人民共和国境内依法登记成立并且合法存续的公司企业法人。在交易平台申请注册、认证交易商时，应向交易平台提交营业执照、开户许可证、法定代表人身份证（复印件应加盖公章）等资料，乙方对申请资料内容的真实性负完全责任，如申请资料的内容发生变更时，应及时提出变更申请，并提交相关资料，否则由此产生的全部责任由乙方承担。",
        },
        {
          cls: C.body,
          text: "第四条乙方须充分阅读并完全理解甲方制定的交易规则、管理办法及相关规定、修订，知悉在甲方提供的交易场所及交易平台中享有的权利和应履行的义务。乙方同意甲方使用乙方的相关资料（包括甲方持有的乙方提供资料，甲方交易平台上活动所获取的资料或其他方式收集的资料等）解决争议、对纠纷进行处理并采取措施。乙方同意甲方可通过人工或自动程序对乙方的资料进行评价。",
        },
        {
          cls: C.body,
          text: "第五条甲方有权单方修订或补充此协议、交易规则、管理办法等相关规定。乙方对此应予以认可并承诺自愿遵守修订后的协议、交易规则、管理办法等相关规定，若乙方不同意相关变更内容或者不愿接受修订或补充的交易规则、管理办法等规定，应当立即停止使用交易平台服务。",
        },
        { cls: C.section, text: "二、交易账户和密钥的使用" },
        { cls: C.blodBody, text: "第六条交易账户和密钥的使用" },
        {
          cls: C.body,
          text: "1、乙方可获得交易账户，该交易账户只限定乙方使用，不得私自转让、转借或转包给他人使用或将交易密码泄露，乙方必须对其名下的交易账户发生的所有行为及后果承担全部责任。",
        },
        {
          cls: C.body,
          text: "2、乙方自愿使用甲方提供的交易平台，为保证电子交易的安全性，乙方应及时申请办理密钥并及时修改PIN码。在进入甲方交易平台时通过密钥身份认证和输入PIN码进行资金收付及签章操作。",
        },
        {
          cls: C.body,
          text: "3、乙方应即时修改交易初始密码，交易账户一经使用，即为乙方行为。乙方应妥善保管和正确使用交易账户及密钥，因交易账户、密钥使用、遗失或被盗用造成的全部责任，由乙方自行承担。",
        },
        {
          cls: C.body,
          text: "4、乙方登录甲方提供的交易平台指定以使用密钥进行签章操作的形式，作为乙方销售（采购）合同指定的电子签名。",
        },
        {
          cls: C.body,
          text: "5、乙方如发现自己的交易账户或密钥、密码等发生泄露、遗失或被盗用，可及时联系甲方指定客服，以便甲方协助乙方采取相应措施。",
        },
        { cls: C.section, text: "三、乙方的权利和义务" },
        { cls: C.blodBody, text: "第七条乙方可享有的权利" },
        { cls: C.body, text: "1、使用甲方提供的交易平台进行各类交易活动；" },
        {
          cls: C.body,
          text: "2、享有甲方提供的交易组织、合同签订、物流衔接、金融服务、能源资讯等服务；",
        },
        { cls: C.body, text: "3、参与甲方组织的与交易相关的各类活动；" },
        {
          cls: C.body,
          text: "4、对甲方的工作提出意见和建议，对甲方工作人员的违规行为向甲方有关部门举报和投诉；",
        },
        { cls: C.body, text: "5、其他依法依规可享有的权利。" },
        { cls: C.blodBody, text: "第八条乙方应履行的义务" },
        {
          cls: C.body,
          text: "1、依法依规注册并合法使用交易平台，不得通过交易平台发布不真实信息或违法违规内容，不得侵犯第三方合法权益；",
        },
        { cls: C.body, text: "2、遵守甲方的各类交易规则、交易管理制度和相关规定、修订；" },
        { cls: C.body, text: "3、接受甲方的相关业务监管，共同维护好交易平台交易秩序；" },
        { cls: C.body, text: "4、妥善保管交易账户及交易密钥；" },
        { cls: C.body, text: "5、正确使用交易账户，对其在交易账户进行的交易行为和结果负责；" },
        { cls: C.body, text: "6、维护甲方形象和声誉，协助甲方处理各种突发或异常事件；" },
        { cls: C.body, text: "7、发生重大变更事项应及时通知甲方；" },
        {
          cls: C.body,
          text: "8、乙方与其它交易商之间因交易纠纷而发生的仲裁或诉讼，不得将交易中心列为仲裁或诉讼主体，否则视为恶意仲裁或诉讼，交易中心有权按照相关法律法规规定及交易中心制度追究相关主体的法律责任；",
        },
        { cls: C.body, text: "10、其他依法依规应履行的义务。" },
        { cls: C.section, text: "四、甲方的权利和义务" },
        { cls: C.blodBody, text: "第九条甲方可享有的权利" },
        {
          cls: C.body,
          text: "1、因乙方违反法律、法规或甲方交易规则、管理办法等或侵害第三人利益的，甲方可给予乙方警告、要求其违约赔偿、限制/冻结乙方交易权限直至取消交易商资格。同时对乙方的采取的上述措施不免除乙方应承担的法律责任；",
        },
        {
          cls: C.body,
          text: "2、有权对交易平台的交易商数据、交易记录等信息进行查阅、收集并留存。对乙方的交易行为进行监督、管控，一旦出现违反交易平台相关业务规则及规定的情况，均有权采取向乙方询问、要求即时停止违规行为或冻结其交易权限等处理行为；",
        },
        {
          cls: C.body,
          text: "3、因相关政府职能部门、司法机关依据法律、法规的规定，按照法定程序要求甲方提供平台信息资料的，甲方无需征得乙方同意;",
        },
        {
          cls: C.body,
          text: "4、有权不定期修订和补充交易规则、管理办法及相关规定，乙方如继续使用，即视为对此应予以认可并承诺自愿遵守修订后的交易规则和管理办法等相关规定；",
        },
        {
          cls: C.body,
          text: "5、交易平台中全部内容，包括但不限于交易竞价记录、行情、数据、著作、图片、档案、文稿、资讯、资料、平台架构、平台画面的安排、网页设计，均由甲方或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经甲方或其他权利人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开；",
        },
        { cls: C.body, text: "6、其他依法依规可享有的权利。" },
        { cls: C.blodBody, text: "第十条甲方应履行的义务" },
        { cls: C.body, text: "1、为乙方提供交易平台进行各类交易活动；" },
        { cls: C.body, text: "2、提供交易组织、合同签订、物流衔接、金融服务、能源资讯等服务；" },
        { cls: C.body, text: "3、负责维持交易平台的稳定、安全和顺畅运行；" },
        { cls: C.body, text: "4、组织与交易相关的各类活动；" },
        {
          cls: C.body,
          text: "5、接受乙方提出的意见和建议，对其举报和投诉内容进行核实和相应处理；",
        },
        {
          cls: C.body,
          text: "6、对于乙方的委托事项、交易资金、交易交收状况及相关记录等资料负有保密义务，非依法律规定、非经法定有权机关或乙方授权，不得擅自向第三方泄露；",
        },
        { cls: C.body, text: "7、其他依法依规应履行的义务。" },
        { cls: C.section, text: "五、不可抗力条款：" },
        { cls: C.blodBody, text: "第十一条不可抗力" },
        {
          cls: C.body,
          text: "1.乙方通过甲方提供的交易平台参与交易过程中，包括但不限于地震、台风、水灾、火灾、暴动、罢工、战争、恐怖袭击、政府行为、法律规定或适用的变更、国际或国内的禁令或限制以及停电、计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或系统故障、技术故障、电子故障等其他任何超出本条款双方控制的，不能预见或防范、不能避免并不能克服的，并妨碍任何一方全部或部分履行本条款的所有事件导致的风险造成的任何损失甲方不承担任何责任。",
        },
        {
          cls: C.body,
          text: "2.由于不可抗力导致甲方或乙方不能履行本协议条款时，甲乙双方互不承担责任。但遭受不可抗力一方应及时通知对方，并尽力采取措施，防止损失的扩大。",
        },
        { cls: C.section, text: "六、风险揭示" },
        {
          cls: C.body,
          text: "甲方作为第三方交易服务机构，非商品经营主体，不拥有商品资源、不介入商品买卖购销链条，无义务为乙方提供任何形式的担保，并且无需为以下风险造成的损失承担法律责任。",
        },
        { cls: C.blodBody, text: "第十二条风险说明：" },
        {
          cls: C.body,
          text: "1、宏观经济风险：因国内外宏观经济政策的调整变化，可能引起的商品价格方面的异常波动、供求关系的失衡，造成乙方遭受损失的风险。",
        },
        {
          cls: C.body,
          text: "2、政策风险：因国家和政府部门颁布实施新的法律、法规及相关政策发生变化、可能引起的商品价格波动，造成乙方遭受损失的风险。",
        },
        {
          cls: C.body,
          text: "3、不可抗力风险：对于因不可抗力或甲方不可预测或无法控制的原因造成的网络服务中断或其它缺陷，造成乙方遭受损失的风险。",
        },
        { cls: C.body, text: "4、自身过失风险：" },
        {
          cls: C.body,
          text: "（1）由于乙方自身不慎将交易账户、密钥遗失，造成被他人盗用的风险；",
        },
        {
          cls: C.body,
          text: "（2）由于乙方委托他人在交易平台进行的操作，被委托人违背乙方意愿进行买卖或资金支付而造成损失的风险；",
        },
        {
          cls: C.body,
          text: "（3）由于乙方自身缺乏网上交易经验，存在操作不当而产生的交易失误、失败而造成损失的风险；",
        },
        {
          cls: C.body,
          text: "（4）乙方因自身原因未能及时收取和查阅甲方向乙方发送关于交易结果、系统维护及各种必要通知可能造成损失的风险；",
        },
        {
          cls: C.body,
          text: "（5）乙方因自身原因导致资产被司法机关采取财产保全或强制执行措施，或者出现丧失民事行为能力、破产、解散等情况时需提前完成交易可能会造成经济损失的风险。",
        },
        {
          cls: C.body,
          text: "5、未能尽述一切有关交易的各类风险，乙方应认真阅读、了解和掌握本入市协议、其他管理制度及相关规定，并确定已经做好足够的风险评估后办理入市手续。",
        },
        { cls: C.section, text: "七、其它" },
        { cls: C.blodBody, text: "第十三条其它" },
        {
          cls: C.body,
          text: "1、本协议依据中华人民共和国有关法律和甲方交易规则订立。甲方对本协议及作为本协议组成部分的各类文件享有最终解释权。本协议未尽事宜，按国家有关法律、法规、政策、大宗商品交易市场的惯例进行协商解决。",
        },
        {
          cls: C.body,
          text: "2、甲、乙双方因履行本协议产生纠纷，双方应尽可能协商解决。如协商不成，可向甲方所在地有管辖权的法院诉讼解决。",
        },
        {
          cls: C.body,
          text: "3、本协议未尽事宜，甲乙双方一致同意按照甲方制定的交易规则、管理办法及相关规定、修订及其他规则或办法执行，上述规则及办法是本协议不可分割的组成部分，具有同等法律效力。",
        },
        {
          cls: C.body,
          text: "4、本协议自乙方进入甲方交易平台勾选“我已阅读并接受《入市协议》”即表示乙方自愿接受本协议。在完成注册手续提交并经交易平台审核通过后，乙方正式成为交易平台交易商，本协议正式生效。有效期至乙方交易商退市或资格被注销或者乙方注销为止。",
        },
        { cls: C.blank, text: "" },
        { cls: C.blank, text: "" },
        { cls: C.signature, text: "甲方：新疆煤炭交易中心有限公司     乙方：交易商" },
      ];
    },
  },
  methods: {
    toSegments(item) {
      const text = item.text || "";
      if (!text) return [{ text: "", bold: false }];
      if (item.cls === C.title) {
        return [{ text, bold: true }];
      }
      let m = text.match(/^(第[一二三四五六七八九十百]+条)(.*)$/);
      if (m) {
        return [
          { text: m[1], bold: true },
          { text: m[2], bold: false },
        ];
      }
      m = text.match(/^(\d+[、.])(.*)$/);
      if (m) {
        return [
          { text: m[1], bold: true },
          { text: m[2], bold: false },
        ];
      }
      m = text.match(/^(（\d+）)(.*)$/);
      if (m) {
        return [
          { text: m[1], bold: true },
          { text: m[2], bold: false },
        ];
      }
      return [{ text, bold: false }];
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-content {
  height: 500px;
  overflow-y: auto;
  padding: 4px 100px;
  font-size: 18px;
  line-height: 1.8;
  color: #333;
  p {
    margin: 0 0 6px;
    text-align: justify;
    word-break: break-all;
  }
  .p-title {
    text-align: center;
    font-weight: bold;
    font-size: 22px;
    &:first-child {
      margin-bottom: 4px;
    }
    &:nth-child(2) {
      margin-bottom: 14px;
    }
  }
  .p-party {
    margin-top: 6px;
  }
  .p-preface,
  .p-body {
    text-indent: 2em;
  }
  .p-blod-body {
    text-indent: 2em;
    font-weight: bold;
  }
  .p-section {
    font-weight: bold;
    margin-top: 14px;
  }
  .p-blank {
    height: 1em;
    margin: 0;
  }
  .p-signature {
    margin-top: 14px;
    display: flex;
    justify-content: space-between;
  }
  .seg-bold {
    font-weight: bold;
  }
}
</style>
